<template>
  <div>
    <footer class="px-3 px-md-6 px-lg-12 py-3 py-md-6 white--text primary">
      <v-row>
        <v-col cols="12" md="6">
          <div>
            <h6 class="body-1 font-weight-bold mb-3">Service à la clientèle</h6>
            <div class="body-2">
              <ul class="links">
                <li>
                  Lundi au vendredi de 9h à 17h
                </li>
                <li>
                  ✆ Par téléphone : <a href="tel:514-731-3925" class="link link-trim-space">514-731-3925</a> poste 0
                </li>
                <li>
                  ✆ Sans frais : <a href="tel:888-731-9420" class="link link-trim-space">1 888 731-9420</a> poste 0
                </li>
                <li>
                  <a :href="urlSaqRequest" class="link" target="_blank">Soumettre une demande en ligne</a>
                </li>
              </ul>
            </div>
          </div>
        </v-col>
        <v-col cols="12" md="6">
          <div>
            <div>
              <h6 class="body-1 font-weight-bold mb-3">Suivez-nous</h6>
              <div class="d-flex">
                <v-btn
                    target="_blank"
                    text
                    icon
                    color="white"
                    large
                    link
                    tile
                    href="https://www.facebook.com/otstcfq"
                    title="Facebook"
                >
                  <v-icon>mdi-facebook</v-icon>
                </v-btn>
                <v-btn
                    target="_blank"
                    text
                    icon
                    color="white"
                    large
                    link
                    tile
                    href="https://www.linkedin.com/company/otstcfq"
                    title="LinkedIn"
                >
                  <v-icon>mdi-linkedin</v-icon>
                </v-btn>
                <v-btn
                    target="_blank"
                    text
                    icon
                    color="white"
                    large
                    link
                    tile
                    href="https://www1.otstcfq.org/"
                    title="LinkedIn"
                >
                  <v-icon>mdi-web</v-icon>
                </v-btn>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </footer>
  </div>
</template>

<script>

import { getSacUrl } from "@/utils/stringUtils";

export default {
  components: {},
  data () {
    return {
      image_src: require("../assets/logo.jpg"),
    }
  },
  computed: {
    urlSaqRequest() {
      return getSacUrl(this.$route.query.contactId || this.$route.params.contactId)
    },
  }
}
</script>

<style scoped>
.links {
  list-style-type: none;
  margin: 0;
  padding: 0;
}

.link {
  color: white;
  text-decoration: none;
}

.link:hover {
  text-decoration: underline;
}
</style>